import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=345f52b0&scoped=true&"
import script from "./LocationList.vue?vue&type=script&lang=ts&"
export * from "./LocationList.vue?vue&type=script&lang=ts&"
import style0 from "./LocationList.vue?vue&type=style&index=0&id=345f52b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f52b0",
  null
  
)

export default component.exports